import { render, staticRenderFns } from "./ManageUsersRoles.vue?vue&type=template&id=f5bb6e68&"
import script from "./ManageUsersRoles.vue?vue&type=script&lang=ts&"
export * from "./ManageUsersRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports